(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vip-signup-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || window.customElements.get('vip-signup-form')) return;

    class VipSignupForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.submitBtn = this.querySelector('[data-vip-submit]');
        this.feedback = this.querySelector('[data-vip-feedback]');
        this.tagsInput = this.querySelector('[data-vip-tags-input]');
        this.noteInput = this.querySelector('[data-vip-note-input]');
        this.phoneInput = this.querySelector('[data-vip-field="phone"]');
        this.emailInput = this.querySelector('[data-vip-field="email"]');
        this.nameInput = this.querySelector('[data-vip-field="name"]');
        this.consentInput = this.querySelector('[data-vip-field="consent"]');

        this.whatsappUrl = this.dataset.whatsappUrl || '';
        this.enablePhoneTagFallback = this.dataset.enablePhoneTag === 'true';
        this.successMessage = this.dataset.successMessage || 'Cadastro confirmado. Redirecionando para o WhatsApp.';
        this.errorMessage = this.dataset.errorMessage || 'Não foi possível concluir seu cadastro. Confira os dados e tente novamente.';
        this.isSubmitting = false;

        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      sanitizePhone(value) { return (value || '').replace(/\D/g, ''); }
      isValidEmail(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value || '').trim()); }
      isValidPhone(digits) { return digits.length >= 10 && digits.length <= 13; }

      canAjaxSubmit() {
        if (typeof window.fetch !== 'function' || typeof window.FormData !== 'function') return false;
        return !(window.Shopify && window.Shopify.captcha);
      }

      showFeedback(type, message) {
        if (!this.feedback) return;
        this.feedback.hidden = false;
        this.feedback.classList.remove('vip-campaign__feedback--success', 'vip-campaign__feedback--error');
        this.feedback.classList.add('vip-campaign__feedback--' + type);
        this.feedback.textContent = message;
      }

      clearFeedback() {
        if (!this.feedback) return;
        this.feedback.hidden = true;
        this.feedback.textContent = '';
        this.feedback.classList.remove('vip-campaign__feedback--success', 'vip-campaign__feedback--error');
        [this.nameInput, this.phoneInput, this.emailInput, this.consentInput].forEach(function (field) {
          if (field) field.removeAttribute('aria-invalid');
        });
      }

      normalizeSuccessLocation() {
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + window.location.search + '#vip-canal-top');
        }

        var target = document.getElementById('vip-canal-top');
        if (target && typeof target.scrollIntoView === 'function') {
          target.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
      }

      setLoading(isLoading) {
        this.isSubmitting = isLoading;
        if (!this.submitBtn) return;
        this.submitBtn.disabled = isLoading;
        this.submitBtn.setAttribute('aria-busy', String(isLoading));
      }

      validate() {
        var errors = [];
        if (!this.nameInput || !this.nameInput.value.trim()) {
          errors.push({ field: this.nameInput, message: 'Informe seu nome.' });
        }
        var phoneDigits = this.sanitizePhone(this.phoneInput && this.phoneInput.value);
        if (!this.isValidPhone(phoneDigits)) {
          errors.push({ field: this.phoneInput, message: 'Informe um WhatsApp válido com DDD.' });
        }
        if (!this.isValidEmail(this.emailInput && this.emailInput.value)) {
          errors.push({ field: this.emailInput, message: 'Informe um e-mail válido.' });
        }
        return { valid: errors.length === 0, errors: errors, phoneDigits: phoneDigits };
      }

      prepareCustomerFields(phoneDigits) {
        if (this.phoneInput) this.phoneInput.value = phoneDigits;
        if (this.noteInput) this.noteInput.value = 'Canal VIP Sincere | WhatsApp: ' + phoneDigits + ' | LGPD opt-in: sim';

        if (!this.enablePhoneTagFallback || !this.tagsInput || !phoneDigits) return;
        var current = (this.tagsInput.value || '').split(',').map(function (tag) { return tag.trim(); }).filter(Boolean);
        var phoneTag = 'phone-' + phoneDigits;
        if (current.indexOf(phoneTag) === -1) {
          current.push(phoneTag);
          this.tagsInput.value = current.join(',');
        }
      }

      pushLeadTracking() {
        var eventName = this.dataset.leadTrackingEvent || 'Lead';
        var formId = this.form && this.form.id ? this.form.id : 'vip-canal-form';
        var payload = {
          event: eventName,
          lead_source: 'canal_vip',
          lead_type: 'whatsapp_vip',
          form_id: formId,
          page_path: window.location.pathname,
          page_location: window.location.href,
          tracking_context: 'shopify_customer_form'
        };
        var trackingKey = 'sincere_meta_lead_v1:' + eventName + ':' + formId + ':' + window.location.pathname;

        try {
          if (window.sessionStorage && window.sessionStorage.getItem(trackingKey)) return;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(payload);
          if (window.sessionStorage) window.sessionStorage.setItem(trackingKey, '1');
        } catch (error) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(payload);
        }
      }

      async onSubmit(event) {
        if (this.isSubmitting) return;
        this.clearFeedback();

        var result = this.validate();
        if (!result.valid) {
          event.preventDefault();
          var first = result.errors[0];
          this.showFeedback('error', first.message);
          if (first.field && typeof first.field.focus === 'function') {
            first.field.setAttribute('aria-invalid', 'true');
            first.field.focus();
          }
          return;
        }

        this.prepareCustomerFields(result.phoneDigits);
        this.setLoading(true);

        if (!this.canAjaxSubmit()) return;
        event.preventDefault();

        try {
          var formData = new FormData(this.form);
          var response = await fetch(this.form.action || '/contact', {
            method: 'POST',
            body: formData,
            headers: { Accept: 'text/html,application/xhtml+xml' },
            redirect: 'follow',
            credentials: 'same-origin'
          });
          var finalUrl = response.url || '';
          var responseText = '';
          try { responseText = await response.text(); } catch (error) { responseText = ''; }

          var success = finalUrl.indexOf('customer_posted=true') !== -1
            || /[?&]customer_posted=true(&|$)/.test(finalUrl)
            || /customer_posted=true/.test(responseText);

          if (success) {
            this.pushLeadTracking();
            this.showFeedback('success', this.successMessage);
            this.normalizeSuccessLocation();
            this.form.reset();
            if (this.whatsappUrl && this.whatsappUrl !== '#') {
              setTimeout(function (self) { window.location.href = self.whatsappUrl; }, 650, this);
            } else {
              this.setLoading(false);
            }
            return;
          }

          this.showFeedback('error', this.errorMessage);
          this.setLoading(false);
        } catch (error) {
          this.showFeedback('error', this.errorMessage);
          this.setLoading(false);
        }
      }
    }

    window.customElements.define('vip-signup-form', VipSignupForm);
  })();

  } catch(e) { console.error(e); }
})();
})();
